"use strict";

var LoggerInstance = require("js-logger").get("CategoryStore");

var AbstractStore = require("./AbstractStore");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var state = {
	categories: [],
	wizardCategories: {}
};

var CategoryStore = class extends AbstractStore {
	getState() {
		return state;
	}

	get(key) {
		return state[key];
	}
};
CategoryStore = new CategoryStore();

CategoryStore.dispatchToken = Dispatcher.register(function (action) {
	switch (action.actionType) {
		case Constants.CATEGORY_INITIALIZE:
			state.categories = action.categories,
			state.wizardCategories = action.wizardCategories;
			return true; // Don't emit change

		default:
			// no op
			return true;
	}

	CategoryStore.emitChange();
	return true;
});

module.exports = CategoryStore;
